export class Box {
    length: number;
    width: number;
    height: number;
    amount: number;


    constructor(length: number, width: number, height: number, amount: number) {
        this.length = length;
        this.width = width;
        this.height = height;
        this.amount = amount;
    }


}